import { Wiring } from '../wiring.interfaces';
import { CONFIG_WIRING } from './config.wiring';
import { CORE_WIRING } from './core.wiring';
import { EMPATHIZE_WIRING } from './empathize.wiring';
import { HISTORY_WIRING } from './history.wiring';
import { LOCALE_WIRING } from './locale.wiring';
import { NO_RESULTS_WIRING } from './no-results.wiring';
import { QUERY_SIGNALS_WIRING } from './query-signals.wiring';
import { RECOMMENDATIONS_WIRING } from './recommendations.wiring';
import { SEARCH_WIRING } from './search.wiring';
import { SORT_WIRING } from './sort.wiring';
import { TRACKING_WIRING } from './tracking.wiring';

export const WIRING: Wiring = {
  ...CORE_WIRING,
  ...CONFIG_WIRING,
  ...EMPATHIZE_WIRING,
  ...HISTORY_WIRING,
  ...LOCALE_WIRING,
  ...NO_RESULTS_WIRING,
  ...QUERY_SIGNALS_WIRING,
  ...SEARCH_WIRING,
  ...SORT_WIRING,
  ...RECOMMENDATIONS_WIRING,
  ...TRACKING_WIRING
};
